import qs from 'qs';
import { client } from '@/client';

// 查询所有的备集群的服务发现配置关系
export function getServiceDiscoveryList() {
  return client.get(`/api/service_discovery/list`);
}

// 绑定备集群
export function bindDisasterRecoveryCluster(params) {
  return client.post(`/api/recovery/recoveryCluster/bind`, params);
}

// 解除备集群
export function unbindDisasterRecoveryCluster(params) {
  return client.delete(`/api/recovery/recoveryCluster/unbind`, params);
}

// 修改备集群
// export function updateDisasterRecoveryCluster(params) {
//   return client.post(`/api/recovery/recoveryCluster/updateBind`, params);
// }

// 切换当前服务集群
export function changeCurrentProvideServiceCluster(params) {
  return client.post(
    `/api/service_discovery/changeCurrentProvideServiceCluster${qs.stringify(params, {
      addQueryPrefix: true,
    })}`,
    params,
  );
}
